module.exports = __webpack_public_path__ + "static/media/perfil.f116e6f9.svg";